import script from "./SignupView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupView.vue?vue&type=script&setup=true&lang=ts"

import "./SignupView.vue?vue&type=style&index=0&id=1de2e817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de2e817"]])

export default __exports__